export default __webpack_public_path__ + "static/media/about.14574b57.png";